const EventEmitter = require('events');
const log = require('debug')('ro:emitter');

class Emitter extends EventEmitter {
    off() {
        this.removeListener(...arguments);
    }

    emit(name, ...args) {
        log(`Emitting event ${name}`, ...args);
        super.emit(name, ...args);
    }
}

export default Emitter;


// WEBPACK FOOTER //
// ./src/core/eventEmitter.js